import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { Auth } from '../../../../../autentication/Auth';
import { SharedService } from '../../../../../shared/shared.service';
import { Util } from '../../../../../utils/util';
import { PixKeyType } from '../../../models/key-type.enum';
import { PixQrCodeReturn } from '../../../models/qr-code-return.model';
import { PixQrCodeDynamicService } from '../qr-code-dynamic.service';
import { PixQrCodeDynamicModalDateComponent } from './modal-date/modal-date.component';
import { PixQrCodeDynamicModalMsgComponent } from './modal-msg/modal-msg.component';
import { PixQrCodeDynamicModalValueComponent } from './modal-value/modal-value.component';

@Component({
	selector: 'app-pix-qr-code-dynamic-resume-final',
	templateUrl: './resume-final.component.html',
	styleUrls: ['./resume-final.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixQrCodeDynamicResumeFinalComponent implements OnInit {
	public pixQrCodeReturn: PixQrCodeReturn;
	public meuNome: string;
	public meuCpfCnpj: string;
	public saldoSaque = 9999999999999;
	public limiteDisponivel = 9999999999999;
	public saldoParcial = 9999999999999;
	public showBalanceLimit = false;

	constructor(
		private router: Router,
		private pixQrCodeDynamicService: PixQrCodeDynamicService,
		private dialog: MatDialog,
		private sharedService: SharedService
	) {}

	ngOnInit(): void {
		this.pixQrCodeReturn = this.pixQrCodeDynamicService.getSelectedPixQrCodeReturn();
		this.meuNome = Auth.getInstance().getUser().name;
		this.meuCpfCnpj = Auth.getInstance().getUser().cpf;
		this.invalidParams();
		this.getBalance();
	}

	getBalance(): void {
		this.sharedService.getBalance().subscribe( (data: any) => {
			this.saldoSaque = data.Retorno.SaldoSaque;
			this.saldoParcial = data.Retorno.SaldoParcial;
			this.limiteDisponivel = data.Retorno.LimiteDisponivel;
		});
	}

	showInfoSaldo(): boolean {
		const availableBalance = this.availableBalanceValue();
		const value = this.inputValue();

		this.showBalanceLimit = false;
		if (availableBalance + this.limiteDisponivel >= value) {
			this.showBalanceLimit = true;
		}

		return (value > availableBalance && !this.showBalanceLimit);
  }

  getTextSaldo(): string {
		this.showBalanceLimit = false;
		return `Você não possui saldo disponível para realizar este pagamento`;
  }

	showInfoSaldoLimiteOmniPlus(): boolean {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();

		if(inputValue > availableBalance || this.limiteDisponivel > 0){
			if(availableBalance < inputValue){
				return availableBalance + this.limiteDisponivel >= inputValue && this.limiteDisponivel > 0;
			}
		}
		return false;
  }

	getTextSaldoLimiteOmniPlus(): string {
		this.showBalanceLimit = true;
		return `Nesta operação você utilizará <b>${this.getLimitValue()}</b> do seu <b>Limite Omni Plus</b> e estará sujeito a cobrança de encargos proporcionais aos dias de uso do limite.`;
	}

	getLimitValue(): string {
		const availableBalance = this.availableBalanceValue();
		const inputValue = this.inputValue();
		return Util.formatValue(inputValue - availableBalance);
	}

	availableBalanceValue(): number {
		return this.saldoParcial >= 0 ? this.saldoParcial : 0;
	}

	inputValue(): number {
		return this.pixQrCodeReturn.valor;
	}

	invalidParams(): void {
		if (this.pixQrCodeReturn === undefined || this.pixQrCodeReturn.valor === undefined || this.pixQrCodeReturn.chavePix === undefined) {
			this.goBack();
		}
	}


	editValue() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalValueComponent, {
			width: '250px',
			data: {
				value: this.pixQrCodeReturn.valor
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.valor = result;
			}
		});
	}

	editDate() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalDateComponent, {
			width: '250px',
			data: {
				date: this.pixQrCodeReturn.qrCodeDinamico.calendario.dataCriacao,
				maxDate: this.pixQrCodeReturn.qrCodeDinamico.calendario.dataExpiracao
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.qrCodeDinamico.calendario.dataCriacao = result;
			}
		});
	}

	editMsg() {
		const dialogRef = this.dialog.open(PixQrCodeDynamicModalMsgComponent, {
			width: '250px',
			data: {
				msg: this.pixQrCodeReturn.qrCodeDinamico.mensagem
			}
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.pixQrCodeReturn.qrCodeDinamico.mensagem = result;
			}
		});
	}

	confirm() {
		this.router.navigate(['pix/pagamento/qrcode-dinamico/assinatura']);
	}

	get keyType(): typeof PixKeyType {
		return PixKeyType;
	}

	goBack = () => this.router.navigate(['pix/pagamento/pix-copia-cola']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/resume-final/resume-final.component.ts